import { useMemo } from 'react';
import { useLDFlags } from '~/core/launch-darkly/hooks/useLDFlags';
import { isTriageManuallyEnabled } from '~/core/util/account';
import { useAccount } from '~/hooks/account/useAccount';

/**
 * Some users who have gone through a particular email flow should always see triage regardless
 * of LD status for continuity, so this flag checks the union of those two options.
 */
export function useTriageEnabled() {
  const { triageEnabled } = useLDFlags();

  const accountSummary = useAccount();

  const triageManuallyEnabledForThisUser =
    accountSummary && isTriageManuallyEnabled(accountSummary);

  const shouldShow = useMemo(
    () => triageEnabled || triageManuallyEnabledForThisUser,
    [triageEnabled, triageManuallyEnabledForThisUser]
  );

  return shouldShow;
}
